import common from "./common";

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function highlightText(text, subqueries) {
  const value = text == null ? "" : String(text);
  if (!value) return value;
  if (!subqueries || subqueries.length === 0) return value;

  const normalizedValue = common.normalizeText(value);
  const terms = Array.from(
    new Set(
      subqueries
        .map((s) => (typeof s === "string" ? s : s?.text))
        .filter(Boolean)
        .map((t) => String(t).trim())
        .filter(Boolean),
    ),
  ).sort((a, b) => b.length - a.length);

  if (terms.length === 0) return value;

  const ranges = [];
  for (const term of terms) {
    const pattern = new RegExp(escapeRegex(term), "gi");
    let m;
    while ((m = pattern.exec(normalizedValue)) !== null) {
      const start = m.index;
      const end = start + term.length;
      const overlaps = ranges.some(
        (r) => !(end <= r.start || start >= r.end),
      );
      if (!overlaps) ranges.push({ start, end });
      if (m.index === pattern.lastIndex) pattern.lastIndex++;
    }
  }

  if (ranges.length === 0) return value;
  ranges.sort((a, b) => a.start - b.start);

  const nodes = [];
  let cursor = 0;
  ranges.forEach(({ start, end }, i) => {
    if (cursor < start) nodes.push(value.slice(cursor, start));
    nodes.push(
      <mark
        key={`hl-${i}-${start}`}
        className="bg-yellow-200 text-inherit rounded-sm px-0.5"
      >
        {value.slice(start, end)}
      </mark>,
    );
    cursor = end;
  });
  if (cursor < value.length) nodes.push(value.slice(cursor));

  return <>{nodes}</>;
}

export default highlightText;
